/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DealTradingPartyResponse { 
    Id?: string;
    Name?: string;
    Ean?: number;
    CanInitiate?: boolean;
    /**
     * A Date Time representation with zone information
     */
    Until?: string | null;
}

